import styled from 'styled-components';
export const ApplicationAssetFields = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.lg}px;
  width: 100%;

  > .ant-form-item {
    margin-bottom: 0;
  }
`;
export const AssetDropZonePrompt = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
export const ApplicationAssetActions = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  margin-top: ${({ theme }) => theme.spacing.md}px;
`;
export const FormButtonRow = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
export const YearModalFields = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  padding-top: ${({ theme }) => theme.spacing.md}px;
  padding-bottom: ${({ theme }) => theme.spacing.md}px;
`;
export const EditableAssetNameCard = styled.div `
  display: grid;
  grid-template-columns: ${({ theme }) => theme.spacing.lg}px minmax(0, 1fr) auto;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md}px;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.md}px;
  border: thin solid ${({ theme }) => theme.colors.grey_4};
  border-radius: ${({ theme }) => theme.border_radius.md};
  background-color: ${({ theme }) => theme.colors.white_1};
`;
export const EditableAssetFileIcon = styled.span `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.spacing.lg}px;
  height: ${({ theme }) => theme.spacing.lg}px;
  color: ${({ theme }) => theme.colors.grey_2};

  > svg {
    width: 75%;
    height: 100%;
  }
`;
export const EditableAssetNameText = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
  min-width: 0;

  .hd-paragraph {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
export const EditableAssetNameActions = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;
export const BucketAssetFields = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.lg}px;
  width: 100%;

  > .ant-form-item {
    margin-bottom: 0;
  }
`;
export const EditableFileNamesSection = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: 100%;
`;
export const EditableFileNameField = styled.div `
  width: 100%;
`;
export const BucketFormActions = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  margin-top: ${({ theme }) => theme.spacing.md}px;
`;
export const EditFileNameModalFields = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
  padding-top: ${({ theme }) => theme.spacing.md}px;
`;
export const EditFileNameFieldGroup = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
export const ModalButtonRow = styled(FormButtonRow) `
  justify-content: flex-end;
`;
export const FormFillingDrawerHeader = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;
export const FormFillingDrawerTitle = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: fit-content;
`;
export const RelatedFilesPanel = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
  padding: ${({ theme }) => theme.spacing.lg}px 0
    ${({ theme }) => theme.spacing.sm}px;
`;
export const RelatedFilesSections = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
`;
export const RelatedFilesLoading = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  min-height: ${({ theme }) => theme.spacing.xl}px;
  color: ${({ theme }) => theme.colors.grey_2};
`;
export const RelatedFolderGroup = styled.section `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  min-width: 0;
`;
export const RelatedAssetSection = styled.details `
  min-width: 0;
`;
export const RelatedFolderSummary = styled.summary `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  min-width: 0;
  min-height: ${({ theme }) => theme.spacing.xl}px;
  padding: 0;
  border-radius: ${({ theme }) => theme.border_radius.sm};
  cursor: pointer;
  list-style: none;
  transition: background-color 150ms ease;

  &::-webkit-details-marker {
    display: none;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.purple_5};
  }

  &:focus-visible {
    outline: thin solid ${({ theme }) => theme.colors.purple_2};
    outline-offset: ${({ theme }) => theme.spacing.xs}px;
  }
`;
export const RelatedFolderChevron = styled.span `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 20px;
  height: 20px;
  color: ${({ theme }) => theme.colors.grey_2};
  transition: transform 150ms ease;

  > svg {
    width: 100%;
    height: 100%;
  }

  ${RelatedAssetSection}[open] & {
    transform: rotate(-90deg);
  }
`;
export const RelatedFolderIcon = styled.span `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 32px;
  height: 32px;
  color: ${({ theme }) => theme.colors.grey_2};

  > svg {
    width: 32px;
    height: 32px;
    fill: currentColor;
  }
`;
export const RelatedFolderName = styled.span `
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: ${({ theme }) => theme.spacing.sm}px;

  .hd-paragraph {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
export const RelatedAssetList = styled.ul `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  margin: 0;
  padding: ${({ theme }) => theme.spacing.sm}px 0
    ${({ theme }) => theme.spacing.sm}px 36px;
  list-style: none;
`;
export const RelatedAssetCard = styled.li `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: 100%;
  min-width: 0;
  min-height: 24px;
  padding: 0;
  border-radius: ${({ theme }) => theme.border_radius.sm};
  transition: background-color 150ms ease;

  &:hover {
    background: ${({ theme }) => theme.colors.purple_5};
  }
`;
export const RelatedAssetIcon = styled.span `
  display: inline-flex;
  flex: none;
  color: ${({ theme }) => theme.colors.grey_2};
  width: 24px;
  height: 24px;

  > svg {
    width: 18px;
    height: 24px;
  }
`;
export const RelatedAssetName = styled.span `
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;

  .hd-paragraph {
    font-size: ${({ theme }) => theme.fonts.body3};
    line-height: ${({ theme }) => theme.fontsLineHeights.body3};
  }
`;
export const RelatedAssetActions = styled.span `
  display: inline-flex;
  flex: none;
`;
export const RelatedAssetActionButton = styled.button `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: ${({ theme }) => theme.border_radius.md};
  color: ${({ theme }) => theme.colors.grey_2};
  background: ${({ theme }) => theme.colors.transparent};
  > svg {
    width: 19px;
    height: 19px;
  }
  cursor: pointer;
  transition:
    color 150ms ease,
    background-color 150ms ease;

  &:hover {
    color: ${({ theme }) => theme.colors.purple_2};
    background: ${({ theme }) => theme.colors.purple_5};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.purple_2};
    outline-offset: 2px;
  }
`;
